import React from 'react';
import { LineChart } from '@mui/x-charts';
import { Box, Typography } from '@mui/material';


function StpTrendsLineChart({ dataset, title, xAxisLabel }) {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    // Format as '5 Jun'
    return date.toLocaleDateString('en-US', { day: 'numeric', month: 'short' });
  };
  const formatPercentage = (value) => `${value}%`;
  return (
    <Box sx={{ width: "100%", boxSizing: "border-box", padding: "24px", border: '1px solid #E5E5E5', borderRadius: '8px', backgroundColor: 'var(--white)' }}>
      <Typography variant="h6" component="h4" sx={{ fontSize: '20px', fontWeight: 700, color: '#111', mb: 4 }}>
        {title}
      </Typography>
      <LineChart
        dataset={dataset}
        xAxis={[
          {
            id: 'day',
            dataKey: 'day',
            scaleType: 'point',
            label: xAxisLabel,
            valueFormatter: (value, context) => {
              if (context.location === "tick") {
                return ""
              }
              return formatDate(value)
            }
          },
        ]}
        sx={{
          '& .MuiChartsAxis-root .MuiChartsAxis-line': { stroke: 'var(--grey-CCC)' },
          '& .MuiYAxis-root .MuiYAxis-line': { stroke: 'var(--grey-CCC)' },
          '& .MuiChartsAxis-root .MuiChartsAxis-tick': { stroke: 'var(--grey-CCC)' }
        }}
        yAxis={[
          {
            width: 70,
            label: "Percentage",
            min: 0,
            max: 100,
            valueFormatter: formatPercentage
          }
        ]}
        series={[
          {
            id: 'stp_rate',
            label: 'STP rate',
            dataKey: 'stp_rate',
            area: false,
            showMark: false,
            color: '#3287A0', // Light blue area
          },
          {
            id: 'touchless_rate',
            label: 'Touchless rate',
            dataKey: 'touchless_rate',
            area: false,
            showMark: false,
            color: '#543EA3', // Light blue area
          },
          {
            id: 'passed_erp_touchless_rate',
            label: 'Passed ERP touchless rate',
            dataKey: 'passed_erp_touchless_rate',
            area: false,
            showMark: false,
            color: '#1E9B6F', // Light blue area
          },
        ]}
        height={300}
      />
    </Box>
  );
}

export default StpTrendsLineChart;
